import type { FaireProductEntity } from "../../entity_types/product";

export const p_n29hf6b3fy: FaireProductEntity = {
  token: "p_n29hf6b3fy",
  type: "product",
  name: '(KG)SPHERE - CHRYSOCOLLA 2-3.25"',
  brandToken: "b_b1k03395mh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b1c161cf26d52ea8787de5ba2ce9a34cacf0029213a303a49aefa3725cef5176.jpeg",
  galleryImageUrls: [],
  priceDollars: 109.33,
  description:
    "Our Chrysocolla Sphere, measuring between 2-3.25\", is a remarkable piece from Oceanic Linkways Inc. Known for our commitment to quality, we source from 19 countries to bring you this spiritual stone. Chrysocolla, often associated with tranquility and peace, can be a unique addition to your home decor or spiritual practices. It's not just a stone but a visual delight.",
  tags: [],
  msrpDollars: 218.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:06.468Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
